import {generateId} from 'lib/generator';

export const AUDIT_SESSION_HEADER = 'X-Illustrator-Session-Id';

let auditSessionId = null;
let auditSessionStartedAt = null;

/**
 * Starts an audit session unless one is already open.
 */
export function startAuditSession() {
  if (!auditSessionId) {
    auditSessionId = generateId();
    auditSessionStartedAt = Date.now();
  }

  return auditSessionId;
}

export function endAuditSession() {
  auditSessionId = null;
  auditSessionStartedAt = null;
}

export function getAuditSessionId() {
  return auditSessionId;
}

export function getAuditSessionStartedAt() {
  return auditSessionStartedAt;
}
